exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".credit-cards > div[data-v-824c57da] {\n  background: #f9f9f9;\n  font-size: 16px;\n  padding: 12px;\n}\n.credit-cards > div[data-v-824c57da]:nth-child(odd) {\n  background: #ededed;\n}", ""]);

// exports
